import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const ShareVideoPopUp = ({ src, show, onClose, message }) => {
    const [showMsg, setShowMsg] = useState(false);

    const copyurl = () => {
        navigator.clipboard.writeText(src);
        setShowMsg(true);
        setInterval(() => {
            setShowMsg(false);
        }, 10000);
    };

    const closeModel = () => {
        onClose();
    };

    return (
        <div>
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="videosharemodal"
            >
                <Modal.Body className="text-center my-6">
                    <div className="screenAlert-icon screenAlert-success animate">
                        <span className="screenAlert-line screenAlert-tip animateSuccessTip"></span>
                        <span className="screenAlert-line screenAlert-long animateSuccessLong"></span>
                        <div className="screenAlert-placeholder"></div>
                        <div className="screenAlert-fix"></div>
                    </div>
                    {message ? (
                        <p className="font-size-h4">{message}</p>
                    ) : (
                        <p className="font-size-h4">Video URL Copied.</p>
                    )}
                    {showMsg ? (
                        <div className="alert alert-custom alert-light-success text-center py-4 justify-content-center">
                            Copied
                        </div>
                    ) : null}
                    <div className="form-group">
                        <div className="input-group">
                            <input
                                className="form-control"
                                type="text"
                                value={src}
                            />
                            <div class="input-group-append">
                                <button
                                    class="btn btn-primary"
                                    type="button"
                                    onClick={() => copyurl(src)}
                                >
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                    <Button
                        className="px-5 mt-10"
                        variant="primary"
                        onClick={() => {
                            closeModel();
                        }}
                    >
                        OK
                    </Button>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ShareVideoPopUp;
